import { FiSave, FiStar } from "react-icons/fi";

interface ActionButtonProps {
    onClick: () => void | Promise<unknown>;
    loading: boolean;
    disabled: boolean;
    text: string;
    loadingText: string;
    variant?: "primary" | "ghost";
    icon?: "generate" | "save";
}

const ActionButton = ({
    onClick,
    loading,
    disabled,
    text,
    loadingText,
    variant = "primary",
    icon = "generate",
}: ActionButtonProps) => {
    const isPrimary = variant === "primary";
    const Icon = icon === "save" ? FiSave : FiStar;

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`flex-1 flex items-center justify-center gap-2 px-3.5 py-3 rounded-[9px] text-[13.5px] font-semibold border transition-all duration-150 ${
                disabled
                    ? "opacity-40 cursor-not-allowed pointer-events-none bg-[#26282C] text-[#6B6C72] border-transparent"
                    : isPrimary
                      ? "bg-gradient-to-br from-[#1DA8C6] to-[#14879f] text-[#08151A] border-transparent hover:brightness-110 active:scale-[0.98]"
                      : "bg-[#26282C] text-[#F1F0EA] border-white/[0.07] hover:border-white/[0.14]"
            } ${loading ? "pointer-events-none opacity-85" : ""}`}
        >
            {loading ? (
                <>
                    <div className="w-3.5 h-3.5 rounded-full border-2 border-[rgba(8,21,26,0.3)] border-t-[#08151A] animate-spin" />
                    <span>{loadingText}</span>
                </>
            ) : (
                <>
                    <Icon className="w-[15px] h-[15px] shrink-0" />
                    <span>{text}</span>
                </>
            )}
        </button>
    );
};

export default ActionButton;
